/**
 * =============================================================================
 * Hook: useAffiliateMonthlyProgress
 * Versão: 2.1.0 (Wrapper do overview com suporte a período)
 *
 * Mudanças v2.1.0:
 *   - Repassa `{ startDate, endDate }` ao overview para que o progresso
 *     reflita o período selecionado (não somente o mês corrente).
 * =============================================================================
 */
import {
  useAffiliateHomeOverview,
  type UseAffiliateHomeOverviewParams,
} from '@/hooks/useAffiliateHomeOverview';

export interface AffiliateMonthlyProgress {
  monthStart: string;
  referralsThisMonth: number;
  conversionsThisMonth: number;
  earnedThisMonth: number;
  /** Variação percentual em relação ao período anterior (pode ser null). */
  trendPct: number | null;
}

export function useAffiliateMonthlyProgress(
  params: UseAffiliateHomeOverviewParams = {},
) {
  const q = useAffiliateHomeOverview(params);
  const m = q.data?.monthly;
  const data: AffiliateMonthlyProgress | undefined = m
    ? {
        monthStart: m.month_start,
        referralsThisMonth: m.referrals,
        conversionsThisMonth: m.conversions,
        earnedThisMonth: Number(m.earned ?? 0),
        trendPct: m.trend_pct,
      }
    : undefined;

  return { ...q, data };
}
